/* KWR combideal samenstelpagina */
(function () {
var CHECK = '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 6.15652C1 6.15652 2.03125 6.15652 3.40625 8.56277C3.40625 8.56277 7.22793 2.26069 10.625 1.00027" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
var CHEV = '<svg class="kwr-dd__chev" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
var PAGE = 10;
var COLOR_RE = /kleur|colou?r|farbe|couleur/i;
var GENDERS = ['heren', 'dames', 'kinderen'];
var GLABEL = { heren: 'Heren', dames: 'Dames', kinderen: 'Kinderen' };
var SUBS = { 'Skikleding': 'Jas + broek, zelfde merk', "Ski's + skischoenen": 'Ski + passende schoen', 'Snowboardset': 'Board + binding + schoenen', 'Skihelm + skibril': 'Helm + bril' };
var DEAL_ICONS = { 'Skikleding': ['hoodie', 'pants'], "Ski's + skischoenen": ['ski', 'boot'], 'Snowboardset': ['board', 'boot'], 'Skihelm + skibril': ['helmet', 'goggles'] };

function init(root) {
var dataEl = root.querySelector('[data-kwr-cdb-data]');
if (!dataEl || root.dataset.kwrInit) return;
root.dataset.kwrInit = '1';
var deals = JSON.parse(dataEl.textContent);
var icons = {};
root.querySelectorAll('template[data-icon]').forEach(function (t) { icons[t.getAttribute('data-icon')] = t.innerHTML; });
var groups = [];
deals.forEach(function (d) { if (groups.indexOf(d.group) === -1) groups.push(d.group); });
var params = new URLSearchParams(window.location.search);
var state = { group: groups.indexOf(params.get('deal')) > -1 ? params.get('deal') : groups[0], brand: params.get('merk'), gender: params.get('g'), picks: {}, sel: {}, show: {}, busy: false };

function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
function money(c) { var n = (c / 100).toFixed(2).split('.'); return '€ ' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1]; }
function dealsOf(g) { return deals.filter(function (d) { return d.group === g; }); }
function gendersOf(g) {
var found = {};
dealsOf(g).forEach(function (d) { d.steps.forEach(function (st) { st.products.forEach(function (p) { if (p.g) found[p.g] = 1; }); }); });
return GENDERS.filter(function (x) { return found[x]; });
}
function gender() {
var gs = gendersOf(state.group);
if (gs.length < 2) return null;
if (gs.indexOf(state.gender) < 0) state.gender = gs[0];
return state.gender;
}
function fits(p) { var g = gender(); return !g || !p.g || p.g === g; }
function dealOk(d) { return d.steps.every(function (st) { return st.products.some(fits); }); }
function brandDeals() {
var list = dealsOf(state.group);
if (!(list.length > 1 && list[0].brand)) return [];
var ok = list.filter(dealOk);
return ok.length ? ok : list;
}
function current() {
var list = brandDeals();
if (list.length) {
var b = list.filter(function (d) { return d.brand === state.brand; })[0];
if (!b) { state.brand = list[0].brand; b = list[0]; }
return b;
}
return dealsOf(state.group)[0];
}
function key(si) { var d = current(); return d.group + '|' + d.brand + '|' + si; }
function selKey(si, pi) { return key(si) + '|' + pi; }
function variantOf(si, pi, p) {
var id = state.sel[selKey(si, pi)];
return p.variants.filter(function (x) { return x.id === id; })[0] || p.variants[0];
}
function colorIdx(p) {
var o = p.opts || [];
for (var i = 0; i < o.length; i++) { if (COLOR_RE.test(o[i])) return i; }
return -1;
}
function opt(v, i) { return (v && v.o && v.o[i]) || ''; }
function sizeLabel(v, ci) {
if (!v || !v.o) return v ? v.title : '';
return v.o.filter(function (x, i) { return i !== ci; }).join(' / ');
}
function colors(p, ci) {
var seen = [], out = [];
p.variants.forEach(function (x) { var c = opt(x, ci); if (seen.indexOf(c) === -1) { seen.push(c); out.push(x); } });
return out;
}
function ddHtml(si, pi, value, label, opts) {
return '<div class="kwr-dd" data-dd="' + si + ':' + pi + '"><button type="button" class="kwr-dd__trigger" aria-haspopup="listbox" aria-expanded="false" aria-label="' + label + '"><span class="kwr-dd__value">' + esc(value) + '</span>' + CHEV + '</button><div class="kwr-dd__panel" role="listbox" hidden>' + opts + '</div></div>';
}
function optHtml(text, active, attr) {
return '<button type="button" role="option" class="kwr-dd__option' + (active ? ' is-active' : '') + '" aria-selected="' + active + '" ' + attr + '><span>' + esc(text) + '</span>' + CHECK + '</button>';
}
function pill(attr, val, label, on) {
return '<button type="button" class="kwr-cdb__brand" aria-pressed="' + on + '" ' + attr + '="' + esc(val) + '">' + esc(label) + '</button>';
}

function renderDeals() {
root.querySelector('[data-deals]').innerHTML = groups.map(function (g) {
var ic = (DEAL_ICONS[g] || []).map(function (n) { return '<span>' + (icons[n] || '') + '</span>'; }).join('');
return '<button type="button" role="tab" class="kwr-cdb__deal" aria-selected="' + (g === state.group) + '" data-group="' + esc(g) + '"><span class="kwr-cdb__deal-icons">' + ic + '</span><span class="kwr-cdb__deal-text"><strong>' + esc(g) + '</strong><span>' + esc(SUBS[g] || '') + '</span></span></button>';
}).join('');
}
function renderGenders() {
var gs = gendersOf(state.group), wrap = root.querySelector('[data-gender-wrap]');
wrap.hidden = gs.length < 2;
if (gs.length < 2) return;
var g = gender();
root.querySelector('[data-genders]').innerHTML = gs.map(function (x) { return pill('data-gender', x, GLABEL[x], x === g); }).join('');
}
function renderBrands() {
var list = brandDeals();
var wrap = root.querySelector('[data-brands-wrap]');
wrap.hidden = !list.length;
if (!list.length) return;
current();
root.querySelector('[data-brands]').innerHTML = list.map(function (d) { return pill('data-brand', d.brand, d.brand, d.brand === state.brand); }).join('');
}
function swatches(si, pi, p, v) {
var ci = colorIdx(p);
if (ci < 0) return '';
var list = colors(p, ci);
var cur = opt(v, ci);
if (list.length < 2) return '<div class="kwr-sw-row"><span class="kwr-sw-name">' + esc(cur) + '</span></div>';
var withImg = list.every(function (x) { return !!x.si; });
if (!withImg) {
var copts = list.map(function (x) { var c = opt(x, ci); return optHtml(c, c === cur, 'data-color="' + esc(c) + '"'); }).join('');
return '<div class="kwr-sw-row">' + ddHtml(si, pi, cur, 'Kies je kleur', copts) + '</div>';
}
return '<div class="kwr-sw-row"><div class="kwr-sw-list">' + list.map(function (x) {
var c = opt(x, ci), a = c === cur;
return '<button type="button" class="kwr-sw' + (a ? ' is-active' : '') + '" data-sw="' + si + ':' + pi + '" data-color="' + esc(c) + '" title="' + esc(c) + '" aria-label="Kleur ' + esc(c) + '" aria-pressed="' + a + '"><img src="' + x.si + '" alt="" width="34" height="34" loading="lazy"></button>';
}).join('') + '</div><span class="kwr-sw-name">' + esc(cur) + '</span></div>';
}
function dropdown(si, pi, p, v) {
var ci = colorIdx(p);
var list = ci < 0 ? p.variants : p.variants.filter(function (x) { return opt(x, ci) === opt(v, ci); });
var lab = function (x) { return ci < 0 ? x.title : sizeLabel(x, ci); };
if (!list.length || !lab(list[0]) || lab(list[0]) === 'Default Title') return '';
var opts = list.map(function (x) { return optHtml(lab(x), x.id === v.id, 'data-vid="' + x.id + '"'); }).join('');
return ddHtml(si, pi, lab(v), 'Kies je maat', opts);
}
function renderSteps() {
var d = current();
root.querySelector('[data-steps]').innerHTML = d.steps.map(function (st, si) {
var pick = state.picks[key(si)];
var lim = state.show[key(si)] || PAGE;
var visible = [];
st.products.forEach(function (p, pi) { if (fits(p)) visible.push({ p: p, pi: pi }); });
var cards = visible.slice(0, lim).map(function (it) {
var p = it.p, pi = it.pi;
var picked = pick && pick.pi === pi;
var v = variantOf(si, pi, p);
var price = v ? v.price : p.price;
var img = (v && v.img) || p.img;
return '<div class="kwr-cdb__card' + (picked ? ' is-picked' : '') + '">' +
'<a class="kwr-cdb__img" href="' + p.url + (v ? '?variant=' + v.id : '') + '" target="_blank" rel="noopener">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="240" height="240">' : '') + '</a>' +
'<span class="kwr-cdb__check" aria-hidden="true">' + CHECK + '</span>' +
'<a class="kwr-cdb__name" href="' + p.url + '" target="_blank" rel="noopener">' + esc(p.title) + '</a>' +
swatches(si, pi, p, v) + dropdown(si, pi, p, v) +
'<div class="kwr-cdb__prices"><span class="kwr-cdb__price">' + money(price) + '</span>' + (p.compare > price ? '<span class="kwr-cdb__was">' + money(p.compare) + '</span>' : '') + '</div>' +
'<span class="kwr-cdb__inset">In set: ' + money(Math.round(price * 0.8)) + '</span>' +
'<button type="button" class="kwr-cdb__pick" data-step="' + si + '" data-pi="' + pi + '" aria-pressed="' + !!picked + '">' + (picked ? 'Gekozen' : 'Kies') + '</button></div>';
}).join('');
var more = visible.length > lim ? '<button type="button" class="kwr-cdb__more" data-more="' + si + '">Toon meer producten</button>' : '';
return '<div class="kwr-cdb__step"><div class="kwr-cdb__step-head"><span class="kwr-cdb__num' + (pick ? ' is-done' : '') + '">' + (si + 1) + '</span><h2 class="kwr-cdb__step-title">Kies je ' + esc(st.label.toLowerCase()) + '</h2></div>' +
'<div class="kwr-cdb__grid">' + (cards || '<p>Er zijn op dit moment geen producten beschikbaar.</p>') + '</div>' + more + '</div>';
}).join('');
}
function renderSummary() {
var d = current(), sub = 0, missing = [], rows = '';
d.steps.forEach(function (st, si) {
var pick = state.picks[key(si)];
if (pick) {
var p = st.products[pick.pi];
var v = p.variants.filter(function (x) { return x.id === pick.vid; })[0] || p.variants[0];
var price = v ? v.price : p.price;
var img = (v && v.img) || p.img;
sub += price;
rows += '<div class="kwr-cdb__row"><span class="kwr-cdb__row-img">' + (img ? '<img src="' + img + '" alt="" width="48" height="48">' : '') + '</span><span class="kwr-cdb__row-text"><small>' + esc(st.label) + '</small><b>' + esc(p.title) + '</b>' + (v && v.title !== 'Default Title' ? '<span class="kwr-cdb__row-var">' + esc(v.title) + '</span>' : '') + '</span><span class="kwr-cdb__row-price">' + money(price) + '</span></div>';
} else {
missing.push(st.label.toLowerCase());
rows += '<div class="kwr-cdb__row"><span class="kwr-cdb__row-img">' + (si + 1) + '</span><span class="kwr-cdb__row-text"><small>' + esc(st.label) + '</small><em>Nog kiezen</em></span></div>';
}
});
var disc = Math.round(sub * 0.2);
var g = gender();
root.querySelector('[data-sum-deal]').textContent = [d.group, d.brand, g ? GLABEL[g] : ''].filter(Boolean).join(', ');
root.querySelector('[data-sum-rows]').innerHTML = rows;
root.querySelector('[data-sum-sub]').textContent = money(sub);
root.querySelector('[data-sum-disc]').textContent = '- ' + money(disc);
root.querySelector('[data-sum-total]').textContent = money(sub - disc);
var btn = root.querySelector('[data-add]');
btn.disabled = state.busy || missing.length > 0;
if (!state.busy) btn.querySelector('.btn__text').textContent = 'Set in winkelwagen';
var hint = root.querySelector('[data-hint]');
hint.style.color = '';
hint.textContent = missing.length ? 'Kies nog: ' + missing.join(', ') : '';
}
function render() { renderDeals(); renderGenders(); renderBrands(); renderSteps(); renderSummary(); }
function closeAll() {
root.querySelectorAll('.kwr-dd.is-open').forEach(function (dd) {
dd.classList.remove('is-open');
dd.querySelector('.kwr-dd__trigger').setAttribute('aria-expanded', 'false');
dd.querySelector('.kwr-dd__panel').hidden = true;
});
}
function setVariant(si, pi, vid) {
state.sel[selKey(si, pi)] = vid;
var pk = state.picks[key(si)];
if (pk && pk.pi === pi) pk.vid = vid;
renderSteps(); renderSummary();
}
function pickColor(si, pi, col) {
var prod = current().steps[si].products[pi];
var ci = colorIdx(prod), cur = variantOf(si, pi, prod);
var cands = prod.variants.filter(function (x) { return opt(x, ci) === col; });
if (!cands.length) return;
var same = cands.filter(function (x) { return sizeLabel(x, ci) === sizeLabel(cur, ci); })[0];
setVariant(si, pi, (same || cands[0]).id);
}

root.addEventListener('click', function (e) {
var g = e.target.closest('[data-group]');
if (g) { state.group = g.getAttribute('data-group'); state.brand = null; render(); return; }
var ge = e.target.closest('[data-gender]');
if (ge) {
state.gender = ge.getAttribute('data-gender');
Object.keys(state.picks).forEach(function (k) { if (k.indexOf(state.group + '|') === 0) delete state.picks[k]; });
render(); return;
}
var b = e.target.closest('[data-brand]');
if (b) { state.brand = b.getAttribute('data-brand'); render(); return; }
var sw = e.target.closest('[data-sw]');
if (sw) { var sp = sw.getAttribute('data-sw').split(':'); pickColor(Number(sp[0]), Number(sp[1]), sw.getAttribute('data-color')); return; }
var tr = e.target.closest('.kwr-dd__trigger');
if (tr) {
var dd = tr.closest('.kwr-dd'), was = dd.classList.contains('is-open');
closeAll();
if (!was) { dd.classList.add('is-open'); tr.setAttribute('aria-expanded', 'true'); dd.querySelector('.kwr-dd__panel').hidden = false; }
return;
}
var op = e.target.closest('.kwr-dd__option');
if (op) {
var pos = op.closest('[data-dd]').getAttribute('data-dd').split(':');
if (op.hasAttribute('data-color')) pickColor(Number(pos[0]), Number(pos[1]), op.getAttribute('data-color'));
else setVariant(Number(pos[0]), Number(pos[1]), Number(op.getAttribute('data-vid')));
return;
}
var more = e.target.closest('[data-more]');
if (more) { var k = key(Number(more.getAttribute('data-more'))); state.show[k] = (state.show[k] || PAGE) + PAGE; renderSteps(); return; }
var pk = e.target.closest('.kwr-cdb__pick');
if (pk) {
var si = Number(pk.getAttribute('data-step')), pi = Number(pk.getAttribute('data-pi'));
var p = current().steps[si].products[pi];
state.picks[key(si)] = { pi: pi, vid: variantOf(si, pi, p).id };
renderSteps(); renderSummary(); return;
}
var add = e.target.closest('[data-add]');
if (add && !add.disabled && !state.busy) {
var d = current();
var items = d.steps.map(function (st, i) { return { id: state.picks[key(i)].vid, quantity: 1 }; });
var label = add.querySelector('.btn__text');
var hint = root.querySelector('[data-hint]');
state.busy = true;
add.disabled = true; label.textContent = 'Bezig...'; hint.style.color = ''; hint.textContent = '';
(window.kwrCd ? window.kwrCd.add(items) : Promise.reject(new Error('De pagina is nog niet helemaal geladen. Probeer het opnieuw.')))
.then(function () {
label.textContent = 'Toegevoegd';
hint.textContent = 'Je set staat in je winkelwagen. De 20% korting zie je bij het afrekenen.';
setTimeout(function () { state.busy = false; add.disabled = false; label.textContent = 'Set in winkelwagen'; }, 2500);
})
.catch(function (err) {
state.busy = false; add.disabled = false; label.textContent = 'Set in winkelwagen';
hint.style.color = '#c0392b'; hint.textContent = err.message;
});
}
});
document.addEventListener('click', function (e) { if (!e.target.closest('.kwr-dd')) closeAll(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
render();
}
function boot() { document.querySelectorAll('[data-kwr-cdb]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();